export default {
  getDefaultState: () => {
    return {
      accountingPeriods: [],
      isCallingAccountingPeriods: false
    }
  }
}
